import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, connect } from "react-redux";

import {
  ACCOUNT_ADMIN,
  AUTO_COMPLETE_SELECT_ENABLE,
  DISABLE_REASONS,
  reasonComponents,
} from "../../../shared/Constants";
import Input from "../../../UI/Input/Input";
import {
  checkValidity,
  getTargetUrlDropDownSortedList,
  isAccountDisabled,
  isAccountEnabled,
} from "../../../shared/utility";
import * as actions from "../../../store/actions";
import classes from "./EnableDisableSection.css";
import inputclasses from "../../../UI/Input/Input.css";
import * as Constants from "../../../shared/Constants";
import ReactTooltip from "react-tooltip";

const EnableDisableSection = (props) => {
  const portalsList = useSelector((state) => state.personalInfo.portals);
  const [formState, setFormState] = useState({
    targetPortal: {
      elementType: props.impactedMemberData
        ? "select"
        : AUTO_COMPLETE_SELECT_ENABLE
        ? "autocompleteselect"
        : "select",
      elementConfig: {
        type: "text",
        id: "targetPortal",
        placeholder: "Select One",
        options: [],
        cssProperties: {
          width: "140%",
          left: "-20%",
        },
      },
      value: "",
      validation: {
        required: false,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: true,
      touched: false,
      label: "Target Portal",
      inputType: "QuickSearch",
    },
    reason: {
      elementType: "select",
      elementConfig: {
        type: "text",
        id: "reason",
        placeholder: "Select One",
        options: [],
      },
      value: props.impactedMemberData ? props.impactedMemberData.reason : "",
      validation: {
        required: false,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: true,
      touched: false,
      label: "Reason",
      inputType: "QuickSearch",
    },
    incidentTicket: {
      elementType: "inputKeyPress",
      elementConfig: {
        type: "text",
        id: "incidentTicket",
        placeholder: "Incident Ticket",
        pattern: "[a-zA-Z0-9]{1,30}",
        // title: "Invalid alpha-numeric characters",
      },
      value: props.impactedMemberData
        ? props.impactedMemberData.incidentNumber
          ? props.impactedMemberData.incidentNumber
          : ""
        : "",
      validation: {
        required: false,
      },
      disabled: props.impactedMemberData ? true : false,
      valid: true,
      touched: false,
      label: "Incident Ticket",
      inputType: "QuickSearch",
    },
  });

  const [formIsValid, setFormIsValid] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();

  const memberEsso = useSelector((state) => state.member.member.essoData);

  const reasonList = useSelector((state) => state.member.disableReasons);
  const reasonFailure = useSelector((state) => state.member.getReasonFailure);

  useEffect(() => {
    if (
      localStorage.getItem(DISABLE_REASONS) !== null &&
      !formState.reason.elementConfig.options.length
    ) {
      let updatedForm = { ...formState };
      updatedForm.reason.elementConfig.options = JSON.parse(
        localStorage.getItem(DISABLE_REASONS)
      ).map((status) => ({
        disabled: false,
        value: status.reason,
        displayValue: status.reason,
      }));
      setFormState(updatedForm);
    } else if (!localStorage.getItem(DISABLE_REASONS) && !reasonFailure) {
      dispatch(actions.getReasonList());
    }
    if (
      !formState.targetPortal.elementConfig.options.length &&
      portalsList !== null
    ) {
      let updatedForm = { ...formState };
      const porLst = getTargetUrlDropDownSortedList(portalsList, Constants.ACCOUNT_SECURITY, props.disabledPortals, props.agentUser.userType);
      if (props.impactedMemberData) {
        const lst = porLst.filter(
          (portal) => portal.value === props.impactedMemberData.prtlShrtNm
        );
        updatedForm.targetPortal.value = lst[0]?.value;
      }
      updatedForm.targetPortal.elementConfig.options = porLst;
      setFormState(updatedForm);
    }
    if (Constants.INCIDENT_FORM_ENABLED) {
      if (
        formState.reason.value ===
          "Caller cannot pass two step authentication requirements for identity purposes" &&
        !formState.incidentTicket.disabled
      ) {
        const updatedForm = { ...formState };
        updatedForm.incidentTicket.disabled = true;
        setFormState(updatedForm);
      } else if (
        formState.reason.value !==
          "Caller cannot pass two step authentication requirements for identity purposes" &&
        formState.incidentTicket.disabled
      ) {
        const updatedForm = { ...formState };
        updatedForm.incidentTicket.disabled = false;
        setFormState(updatedForm);
      }
    }
  }, [reasonList, portalsList, formState, props.impactedMemberData]);

  useEffect(() => {
    if (isAccountEnabled(memberEsso)) {
      if (Constants.INCIDENT_FORM_ENABLED) {
        if (
          reasonComponents[formState.reason.value] &&
          formState.targetPortal.value.length > 1
        ) {
          props.isValid(true);
        } else {
          props.isValid(
            formState["reason"].value &&
              formState["incidentTicket"].value &&
              formState.targetPortal.value
          );
        }
      } else if (
        !Constants.INCIDENT_FORM_ENABLED &&
        formState.reason.value !== "" &&
        formState.incidentTicket.value !== "" &&
        formState.targetPortal.value !== ""
      ) {
        props.isValid(true);
      }
    } if (Constants.INCIDENT_FORM_ENABLED) {
      if (props.impactedMemberData) {
        props.isValid(formState.reason.value && formState.targetPortal.value);
      } else if (props.disabledMember && props.userType === Constants.SESSION_SUPERUSER) {
        props.isValid(formState.incidentTicket?.value !== "");
      }
    } else {
      props.isValid(formState["incidentTicket"]?.value !== "");
    }
  }, [formState, props.userType]);

  const inputChangedHandler = (event, inputIdentifier) => {
    let updatedForm = { ...formState };
    const updatedFormElement = { ...updatedForm[inputIdentifier] };
    let targetValue = event.target.value;
    updatedFormElement.value = targetValue;
    let formIsValid = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    if (targetValue) {
      const validation = checkValidity(
        updatedFormElement.value,
        updatedFormElement.validation
      );
      updatedFormElement.valid = validation.isValid;
    } else {
      updatedFormElement.valid = false;
    }

    updatedFormElement.touched = true;
    updatedForm[inputIdentifier] = updatedFormElement;

    for (let inputIdentifier in updatedForm) {
      formIsValid = updatedForm[inputIdentifier].valid && formIsValid;
    }
    setFormState(updatedForm);
    switch (inputIdentifier) {
      case "reason":
        props.setReason(updatedFormElement.value);
        break;
      case "targetPortal":
        props.setTargetPortal(updatedFormElement.value);
        break;
      case "incidentTicket":
        props.setIncidentTicket(updatedFormElement.value);
        break;
      default:
        break;
    }
  };

  //returns a link for prod or non-prod by checking our current environment
  const generateServiceNowIncidentUrl = (incidentNumber) => {
    if (Constants.DEPLOYMENT_ENV_WHITELIST.includes(process.env.NODE_ENV)) {
      //HyperLink for non-prod
      // console.log("link-->",Constants.SERVICE_NOW_BASE_URLS_FOR_INCIDENT_FORM[0]+incidentNumber);
      return (
        Constants.SERVICE_NOW_BASE_URLS_FOR_INCIDENT_FORM[0] + incidentNumber
      );
    } else {
      //HyperLink for prod
      return (
        Constants.SERVICE_NOW_BASE_URLS_FOR_INCIDENT_FORM[1] + incidentNumber
      );
    }
  };

  //This function will open the generated URL in new tab and change the color of incidentNumber to purple
  const changeColorAndOpenUrl = (e) => {
    e.preventDefault();
    // console.log("changeColorAndOpenUrl called");
    window.open(
      generateServiceNowIncidentUrl(props.impactedMemberData.incidentNumber),
      "_blank"
    );
    e.target.style.color = "#961fba";
  };
  const enableDisableForm = (
    <div className={classes.formLayout}>
      {Object.keys(formState)
        .filter((element) => {
          if (props.disabledMember !== null && element === "incidentTicket")
            return element;
          else if (props.disabledMember === null) return element;
        })
        .map((key) => {
          if (
            key === "incidentTicket" &&
            props.impactedMemberData &&
            props.impactedMemberData.incidentNumber
          ) {
            return (
              <>
                <div
                  className={inputclasses.Label}
                  style={{ margin: "0px 0px -7px 10px" }}
                >
                  {"Incident Ticket"}
                  &nbsp;
                  <a data-tip data-for="incidentTicket">
                    <span
                      className="fa fa-question-circle"
                      style={{ fontSize: "18px" }}
                    ></span>{" "}
                  </a>
                  <ReactTooltip id="incidentTicket">
                    <span>
                      For more information, click the incident number shown
                      below
                    </span>
                  </ReactTooltip>
                </div>
                <a
                  id="change"
                  className={classes.incidentForm}
                  onClick={changeColorAndOpenUrl}
                >
                  <Input
                    key={key}
                    className={classes.SecurityInput}
                    elementType="incidentformhyperlink"
                    value={props.impactedMemberData.incidentNumber}
                    inputType={formState[key].inputType}
                  />
                </a>
              </>
            );
          } else {
            return (
              <Input
                key={key}
                className={classes.SecurityInput}
                elementType={formState[key].elementType}
                elementConfig={formState[key].elementConfig}
                value={formState[key].value}
                invalid={!formState[key].valid}
                shouldValidate={formState[key].validation}
                touched={formState[key].touched}
                disabled={formState[key].disabled}
                label={formState[key].label}
                changed={(event) => inputChangedHandler(event, key)}
                inputType={formState[key].inputType}
              />
            );
          }
        })}
    </div>
  );

  return (
    <>
      <div className={classes.FormTitle}>{props.modalTitle}</div>
      <div className={classes.FormElement}>{props.modalText}</div>
      <div className={classes.box}>{enableDisableForm}</div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    impactedMemberData: state.member.impactedMemberData,
    disabledMember: state.member.disabledMember,
    agentUser: state.usr.user,
    disabledPortals: state.addEligibility.disabledPortals
  };
};

export default connect(mapStateToProps, null)(EnableDisableSection);
